import { render } from "./PatientDocumentUploadForm.vue?vue&type=template&id=4c3eaa05&scoped=true"
import script from "./PatientDocumentUploadForm.vue?vue&type=script&lang=js"
export * from "./PatientDocumentUploadForm.vue?vue&type=script&lang=js"

import "./PatientDocumentUploadForm.vue?vue&type=style&index=0&id=4c3eaa05&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3eaa05"]])

export default __exports__